<div class="ftp-select-row">
  <!-- dynamic subscript: no reserved space under the field, so the row centers on it -->
  <mat-form-field appearance="outline" class="ftp-select-field" subscriptSizing="dynamic">
    <mat-label>FTP Service</mat-label>
    <mat-select [formControl]="control" (selectionChange)="onSelectionChange($event.value)" required>
      <mat-option *ngFor="let service of services" [value]="service.id">{{ service.ftpName }}</mat-option>
    </mat-select>
    <mat-error>Select an FTP service.</mat-error>
  </mat-form-field>

  <!-- Selected service: server type and connection status (shared by Ingest and Data Writer;
       the service name is already shown in the dropdown). -->
  <div *ngIf="!loadingList && !listError && selectedService as selected" class="ftp-selected" aria-live="polite">
    <div class="ftp-selected-row">
      <span class="ftp-selected-label">Server Type:</span>
      <span class="server-type" [class.secure]="isSftp(selected)" [class.insecure]="!isSftp(selected)"
            [matTooltip]="isSftp(selected)
              ? 'SFTP encrypts credentials and data in transit — the more secure option.'
              : 'FTP sends credentials and data unencrypted. Prefer SFTP where the server supports it.'">
        <mat-icon>{{ isSftp(selected) ? 'lock' : 'lock_open' }}</mat-icon>
        {{ FtpServerTypeUtil.toString(selected.ftpServerType) }}
      </span>
    </div>

    <div class="ftp-selected-row">
      <span class="ftp-selected-label">Connection Status:</span>
      <ng-container [ngSwitch]="status">
        <span *ngSwitchCase="'testing'" class="connection testing">
          <mat-spinner diameter="16"></mat-spinner> Testing…
        </span>
        <span *ngSwitchCase="'success'" class="connection success">
          <mat-icon>check_circle</mat-icon> Connected
        </span>
        <span *ngSwitchCase="'failed'" class="connection failed" [matTooltip]="statusMessage">
          <mat-icon>cancel</mat-icon> Failed: {{ statusMessage }}
          <button mat-stroked-button type="button" (click)="retry()">Retry</button>
        </span>
        <span *ngSwitchDefault class="connection hint">Not tested</span>
      </ng-container>
    </div>
  </div>

  <div class="ftp-status" aria-live="polite" *ngIf="loadingList || listError || !selectedService">
    <ng-container *ngIf="loadingList">
      <mat-spinner diameter="18"></mat-spinner>
      <span>Loading FTP services…</span>
    </ng-container>

    <ng-container *ngIf="!loadingList && listError">
      <mat-icon class="failed">error_outline</mat-icon>
      <span class="failed">{{ listError }}</span>
      <button mat-stroked-button type="button" (click)="loadServices()">Retry</button>
    </ng-container>

    <ng-container *ngIf="!loadingList && !listError">
      <span *ngIf="services.length === 0" class="hint">
        No active FTP services are configured. An administrator can add one under Organization Settings → FTP.
      </span>

      <span *ngIf="services.length > 0" class="hint">
        <ng-container *ngIf="savedServiceMissing">
          The previously selected FTP service is no longer available. Select another FTP service.
        </ng-container>
        <ng-container *ngIf="!savedServiceMissing && unmatchedHost; else selectHint">
          The saved FTP settings ({{ unmatchedHost }}) don't match a configured FTP service. Select an FTP service.
        </ng-container>
        <ng-template #selectHint><ng-container *ngIf="!savedServiceMissing">Select an FTP service to continue.</ng-container></ng-template>
      </span>
    </ng-container>
  </div>
</div>
